import { render, staticRenderFns } from "./BlipMonitoringAttendantsTable.vue?vue&type=template&id=f3ae8824&scoped=true&"
import script from "./BlipMonitoringAttendantsTable.vue?vue&type=script&lang=js&"
export * from "./BlipMonitoringAttendantsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipMonitoringAttendantsTable.vue?vue&type=style&index=0&id=f3ae8824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ae8824",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
